import React, { useState, useEffect } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 100) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    isVisible && (
      <button
        style={{
          position: "fixed",
          width: "40px",
          height: "40px",
          bottom: "45px",
          right: "20px",
          padding: "0",
          borderRadius: "50%",
          backgroundColor: "#347CCC",
          color: "white",
          border: "none",
          cursor: "pointer",
          zIndex: 99,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <ArrowUpwardIcon
          style={{
            fontSize: "20px"
          }}
        />
      </button>
    )
  );
};

export default ScrollToTopButton;
